
// Import module styles.
import "./performExercise.view.less";

// Define controllers.
window.yqcw6t = {
	FormController
};

// Todo: this isn't how Alpine.js components work, I'm just trying to get rid of inline
// script tags. Will need to refactor this later.
function FormController() {

	(function setupCompareToSets() {

		var form = document.querySelector( "form" );
		var compareToInstance = form.querySelector( "input[name='compareToInstance']" );

		for ( var node of document.querySelectorAll( "button[name='compareSets']" ) ) {

			node.addEventListener( "click", handleCompareSetsClick );

		}

		function handleCompareSetsClick( event ) {

			var target = event.currentTarget;

			compareToInstance.value = target.value;
			form.requestSubmit();

		}

	})();






	var weightHelpNode = document.querySelector( ".weight-help" );
	var totalWeightNode = weightHelpNode.querySelector( "input[name='totalWeight']" );
	var equipmentWeightNode = weightHelpNode.querySelector( "input[name='equipmentWeight']" );
	var weightIncrementButtons = weightHelpNode.querySelectorAll( ".weight-help-incr button" );
	var isEquipmentSplitLoadedNode = weightHelpNode.querySelector( "input[name='isEquipmentSplitLoaded']" );
	var closeWeightHelpButtonNode = weightHelpNode.querySelector( ".close-weight-help .close-only" );
	var closeAndApplyWeightHelpButtonNode = weightHelpNode.querySelector( ".close-weight-help .close-and-apply" );
	var lastActiveWeightNode = null;
	var leftWeightsNode = weightHelpNode.querySelector( ".weight-illustration__left" );
	var rightWeightsNode = weightHelpNode.querySelector( ".weight-illustration__right" );
	var plateListNode = weightHelpNode.querySelector( ".plate-list" );
	var plateList45Node = plateListNode.querySelector( ".plate-list__count.lb-45" );
	var plateList25Node = plateListNode.querySelector( ".plate-list__count.lb-25" );
	var plateList10Node = plateListNode.querySelector( ".plate-list__count.lb-10" );
	var plateList5Node = plateListNode.querySelector( ".plate-list__count.lb-5" );
	var plateList2_5Node = plateListNode.querySelector( ".plate-list__count.lb-2-5" );
	var overflowWeightNote = weightHelpNode.querySelector( ".overflow-weight-note" );
	var overflowWeightNoteRemaineder = weightHelpNode.querySelector( ".overflow-weight-note__remainder" );
	var maxHelpNode = document.querySelector( ".max-help" );
	var maxHelpChoiceElement = document.querySelector( "input[name='max-help__choice']" );
	var maxHelpCloseButton = document.querySelector( ".max-help__close" );
	var maxHelperDebounceTimer;

	closeWeightHelpButtonNode.addEventListener( "click", closeWeightHelperAsModal );
	closeAndApplyWeightHelpButtonNode.addEventListener( "click", closeWeightHelperAsModal );
	totalWeightNode.addEventListener( "input", updateWeightHelp );
	equipmentWeightNode.addEventListener( "input", updateWeightHelp );
	isEquipmentSplitLoadedNode.addEventListener( "input", updateWeightHelp );

	maxHelpCloseButton.addEventListener( "click", closeMaxHelper );

	// Bind to the weight inputs and update as they are updated.
	for ( var inputNode of document.querySelectorAll( ".set__input[name='weight']" ) ) {

		inputNode.addEventListener( "input", handleWeightInput );
		inputNode.addEventListener( "input", handleMaxesInput.bind(null,"weight",true) );//handles max calculations
		inputNode.addEventListener( "focus", handleWeightInput );
		inputNode.addEventListener( "focus", handleWeightFocus );
		inputNode.addEventListener( "input", handleChartingUpdates );

	}

	for ( var inputNode of document.querySelectorAll( ".set__input[name='reps']" ) ) {
		inputNode.addEventListener( "input", handleMaxesInput.bind(null,"reps",true) );
		inputNode.addEventListener( "input", handleChartingUpdates );
	}

	// Bind the helper buttons.
	for ( var openHelpNode of document.querySelectorAll( ".set__help" ) ) {

		openHelpNode.addEventListener( "click", openWeightHelperAsModal );

	}

	// Bind to the incrementer buttons.
	for ( var incrementNode of weightIncrementButtons ) {

		incrementNode.addEventListener( "click", incrementWeightHelper );

	}

	function openWeightHelperAsModal( event ) {

		var parentElement = event.currentTarget.parentElement;
		var weightNode = parentElement.querySelector( ".set__weight" );
		var overlayNode = parentElement.querySelector( ".set__overlay" );

		lastActiveWeightNode = weightNode;
		// If there is no weight entered into the input, use any previous weight
		// that might be available.
		totalWeightNode.value = (
			weightNode.value.trim() ||
			overlayNode.textContent.trim() ||
			""
		);
		updateWeightHelp();

		weightHelpNode.classList.add( "modal" );
		weightHelpNode.scrollTop = 0;
		// totalWeightNode.focus();

	}

	function closeMaxHelper( event ) {
		maxHelpNode.classList.add('hidden');
	}

	function closeWeightHelperAsModal( event ) {

		var button = event.currentTarget;

		weightHelpNode.classList.remove( "modal" );

		if ( lastActiveWeightNode ) {

			if (
				( button === closeAndApplyWeightHelpButtonNode ) ||
				! lastActiveWeightNode.value
				) {

				lastActiveWeightNode.value = totalWeightNode.value;

			}

			lastActiveWeightNode.focus();

		}

	}

	function handleWeightFocus( event ) {

		for ( var node of document.querySelectorAll( ".set" ) ) {

			node.classList.remove( "active" );

		}

		event.currentTarget
			.parentElement
			.parentElement
			.classList
			.add( "active" )
		;

	}

	function incrementWeightHelper( event ) {

		var increment = +event.currentTarget.dataset.increment;
		var currentWeight = ( +totalWeightNode.value || 0 );
		var nextWeight = ( currentWeight + increment );

		totalWeightNode.value = nextWeight;
		updateWeightHelp();

	}

	function handleMaxesInput( inputType, clearTimer, event ) {

		//check if maxHelpChoiceElement is checked. if not, return
		if(!maxHelpChoiceElement || !maxHelpChoiceElement.checked){
			return;
		}

		if(clearTimer){
			clearTimeout(maxHelperDebounceTimer); 

			const target = event.currentTarget

			maxHelperDebounceTimer = setTimeout(function() {
				handleMaxesInput(inputType, false, {currentTarget:target}); // Call the function after a delay
			}, 500); // Adjust the delay (in milliseconds) as needed	

			return;
		}
		
		let inputValue = ( event.currentTarget.value || -1 );

		let repsNode = null;
		let weightNode = null;

		let repsValue = -1;
		let weightValue = -1;

		var parentElement = event.currentTarget.closest('.set');

		switch(inputType){
			case 'weight':
				repsNode = parentElement.querySelector( ".set__input[name='reps']" );
				weightNode = event.currentTarget;
				weightValue = parseInt(inputValue);
				repsValue = parseInt( repsNode.value || -1 );
				break;
			case 'reps':
				weightNode = parentElement.querySelector( ".set__input[name='weight']" );
				repsNode = event.currentTarget;
				weightValue = parseInt( weightNode.value || -1 );
				repsValue = parseInt(inputValue);
				break;
		}

		if(repsValue > 0 && weightValue < 0){//get suggested weight
		}
		else if(weightValue > 0 && repsValue < 0){//get suggested reps
		}
		else{//else, no suggestion
			return;
		}
		

		// var formData = new FormData( form );
		var fetchPath = '?event=member.exerciseMax';
		var exerciseID = maxHelpNode.dataset.exerciseId;
		var format = 'json';
		
		fetch(
			`${fetchPath}&exercise=${exerciseID}&reps=${repsValue}&weight=${weightValue}&format=${format}`,)
		.then(response =>{
			
			if (!response.ok) {
				console.error(new Error('Network response was not ok'));
			}
			return response.json();
		})
		.then(data => {
			//just put the json data into the maxHelpNode. we can get cuter later

			const inputElement = event.currentTarget;
			const rect = inputElement.getBoundingClientRect();

			//find children of maxHelpNode with class of max-help-child and set display to hidden
			const children = maxHelpNode.querySelectorAll('.max-help-child');
			children.forEach(child => {
				child.classList.add('hidden');
			});
			
		
			

			if(data.length > 0){
				data = data[0];
				const reps = data.set.reps;
				const weight = data.set.weight;
				const date = data.set.date;
				const label = data.label;

				
				const childNode = maxHelpNode.querySelector(`.${label}`);

				//set the data values inthe the childNode elements
				if(childNode.querySelector('.rep-max')){
					childNode.querySelector('.rep-max').innerHTML = reps ?? '';

					if(!reps || reps <= 0 ){
						childNode.querySelector('.max-achievement-date-container').classList.add('hidden');
					}
					else{
						childNode.querySelector('.max-achievement-date-container').classList.remove('hidden');
					}
				}

				if(childNode.querySelector('.weight-max')){
					childNode.querySelector('.weight-max').innerHTML = weight ?? '';

					if(!weight || weight <=0 ){
						childNode.querySelector('.max-achievement-date-container').classList.add('hidden');
					}
					else{
						childNode.querySelector('.max-achievement-date-container').classList.remove('hidden');
					}
				}

				if(childNode.querySelector('.weight-entered')){
					childNode.querySelector('.weight-entered').innerHTML = weightValue ?? '';
				}

				if(childNode.querySelector('.reps-entered')){
					childNode.querySelector('.reps-entered').innerHTML = repsValue ?? '';
				}

				if(childNode.querySelector('.max-achievement-date')){
					childNode.querySelector('.max-achievement-date').innerHTML = date ?? '';
				}

				// remove the hidden class from the appropriate child where label = the class name
				childNode.classList.remove('hidden');
			}

			//place the node directly beneath the input. It is already absolutely positioned. need to set the top. left position will depend on the screen size and handled in the css
			maxHelpNode.style.top = rect.top + window.scrollY + inputElement.offsetHeight + 5 + 'px';
			//remove the hidden class from the node
			maxHelpNode.classList.remove('hidden');

			//set a timeout to re-hide the node after a few seconds
			setTimeout(function(){
				closeMaxHelper();
			}, 7000);


			
		} )
		.catch(
			( error ) => {

				// NOTE: This only represents transport errors, not HTTP error
				// responses from the server. We don't care about server
				// responses since we're only optimistically saving the form.
				console.group( "Max Calculation Error" );
				console.error( error );
				console.groupEnd();

			}
		);


	}

	function handleWeightInput( event ) {

		lastActiveWeightNode = event.currentTarget;
		totalWeightNode.value = ( event.currentTarget.value || "" );
		updateWeightHelp();

	}

	function updateWeightHelp() {

		var totalWeight = ( Number( totalWeightNode.value ) || 0 );
		var equipmentWeight = ( Number( equipmentWeightNode.value ) || 0 );
		var loadedWeight = Math.max( ( totalWeight - equipmentWeight ), 0 );
		var isTwoSided = isEquipmentSplitLoadedNode.checked;

		var weights = {
			"45": 0,
			"25": 0,
			"10": 0,
			"5": 0,
			"2.5": 0
		};

		var remainingWeight = ( isTwoSided )
			? ( loadedWeight / 2 )
			: loadedWeight
		;

		weights[ "45" ] = Math.floor( remainingWeight / 45 );
		remainingWeight -= ( weights[ "45" ] * 45 );

		weights[ "25" ] = Math.floor( remainingWeight / 25 );
		remainingWeight -= ( weights[ "25" ] * 25 );

		weights[ "10" ] = Math.floor( remainingWeight / 10 );
		remainingWeight -= ( weights[ "10" ] * 10 );

		weights[ "5" ] = Math.floor( remainingWeight / 5 );
		remainingWeight -= ( weights[ "5" ] * 5 );

		weights[ "2.5" ] = Math.floor( remainingWeight / 2.5 );
		remainingWeight -= ( weights[ "2.5" ] * 2.5 );

		// Clear both sides.
		leftWeightsNode.replaceChildren();
		rightWeightsNode.replaceChildren();

		if ( remainingWeight ) {

			overflowWeightNote.classList.add( "active" );
			overflowWeightNoteRemaineder.textContent = ( isTwoSided )
				? ( remainingWeight * 2 )
				: remainingWeight
			;

		} else {

			overflowWeightNote.classList.remove( "active" );

		}

		// We only want to render the illustration if the number of places is
		// reasonably small. Otherwise, we might crash the browser.
		if ( loadedWeight <= 1000 ) {

			for ( var i = 0 ; i < weights[ "45" ] ; i++ ) {

				var plate = document.createElement( "span" );
				plate.classList.add( "weight-illustration__plate", "lb-45" );

				leftWeightsNode.prepend( plate.cloneNode() );

				if ( isTwoSided ) {

					rightWeightsNode.append( plate.cloneNode() );

				}

			}

			for ( var i = 0 ; i < weights[ "25" ] ; i++ ) {

				var plate = document.createElement( "span" );
				plate.classList.add( "weight-illustration__plate", "lb-25" );

				leftWeightsNode.prepend( plate.cloneNode() );

				if ( isTwoSided ) {

					rightWeightsNode.append( plate.cloneNode() );

				}

			}

			for ( var i = 0 ; i < weights[ "10" ] ; i++ ) {

				var plate = document.createElement( "span" );
				plate.classList.add( "weight-illustration__plate", "lb-10" );

				leftWeightsNode.prepend( plate.cloneNode() );

				if ( isTwoSided ) {

					rightWeightsNode.append( plate.cloneNode() );

				}

			}

			for ( var i = 0 ; i < weights[ "5" ] ; i++ ) {

				var plate = document.createElement( "span" );
				plate.classList.add( "weight-illustration__plate", "lb-5" );

				leftWeightsNode.prepend( plate.cloneNode() );

				if ( isTwoSided ) {

					rightWeightsNode.append( plate.cloneNode() );

				}

			}

			for ( var i = 0 ; i < weights[ "2.5" ] ; i++ ) {

				var plate = document.createElement( "span" );
				plate.classList.add( "weight-illustration__plate", "lb-2-5" );

				leftWeightsNode.prepend( plate.cloneNode() );

				if ( isTwoSided ) {

					rightWeightsNode.append( plate.cloneNode() );

				}

			}

		}

		// Update plate list.
		if ( weights[ "45" ] ) {

			plateList45Node.textContent = weights[ "45" ];
			plateList45Node.parentNode.classList.remove( "empty" );

		} else {

			plateList45Node.textContent = "";
			plateList45Node.parentNode.classList.add( "empty" );

		}

		if ( weights[ "25" ] ) {

			plateList25Node.textContent = weights[ "25" ];
			plateList25Node.parentNode.classList.remove( "empty" );

		} else {

			plateList25Node.textContent = "";
			plateList25Node.parentNode.classList.add( "empty" );

		}

		if ( weights[ "10" ] ) {

			plateList10Node.textContent = weights[ "10" ];
			plateList10Node.parentNode.classList.remove( "empty" );

		} else {

			plateList10Node.textContent = "";
			plateList10Node.parentNode.classList.add( "empty" );

		}

		if ( weights[ "5" ] ) {

			plateList5Node.textContent = weights[ "5" ];
			plateList5Node.parentNode.classList.remove( "empty" );

		} else {

			plateList5Node.textContent = "";
			plateList5Node.parentNode.classList.add( "empty" );

		}

		if ( weights[ "2.5" ] ) {

			plateList2_5Node.textContent = weights[ "2.5" ];
			plateList2_5Node.parentNode.classList.remove( "empty" );

		} else {

			plateList2_5Node.textContent = "";
			plateList2_5Node.parentNode.classList.add( "empty" );

		}

	}


	(function setupInputmodeToggling() {

		var toggleToText = document.querySelector( ".keyboard-toggle__control.text" );
		var toggleToNumeric = document.querySelector( ".keyboard-toggle__control.numeric" );
		var tempInput = document.querySelector( ".keyboard-toggle__temp" );
		var setInputs = document.querySelectorAll( ".set__input" );
		var lastActiveInput = null;

		toggleToText.addEventListener( "input", handleToggleClick );
		toggleToNumeric.addEventListener( "input", handleToggleClick );

		for ( var input of setInputs ) {

			input.addEventListener( "focus", handleInputFocus );

		}

		updateInputs();

		function handleInputFocus( event ) {

			lastActiveInput = event.currentTarget;

		}

		function handleToggleClick( event ) {

			updateInputs();

			if ( lastActiveInput ) {

				tempInput.focus();
				requestAnimationFrame( () => lastActiveInput.focus() );

			}

		}

		function updateInputs() {

			if ( toggleToText.checked ) {

				var inputMode = "text";
				var pattern = ".*";

			} else {

				var inputMode = "decimal";
				var pattern = "[0-9.]*";

			}

			for ( var input of setInputs ) {

				input.inputMode = inputMode;
				input.pattern = pattern;

			}

		}

	})();



	for ( var node of document.querySelectorAll( ".set__input" ) ) {

		if ( node.value === "" ) {

			node.focus();
			node.scrollIntoView({
				behavior: "smooth",
				block: "center"
			});
			break;

		}

	}



	(function setupPrevNotesCycling() {

		var notes = document.querySelectorAll( ".prev-notes__info" );
		var nextNote = document.querySelector( ".prev-notes__nav--next" );
		var prevNote = document.querySelector( ".prev-notes__nav--prev" );
		var activeIndex = 0;
		var maxIndex = ( notes.length - 1 );

		if ( ! nextNote || ! prevNote ) {

			return;

		}

		nextNote.addEventListener( "click", gotoNextNote );
		prevNote.addEventListener( "click", gotoPrevNote );

		function gotoNextNote( event ) {

			clearActive();

			activeIndex = ( activeIndex > 0 )
				? ( activeIndex - 1 )
				: maxIndex
			;

			applyActive();

		}

		function gotoPrevNote( event ) {

			clearActive();

			activeIndex = ( activeIndex < maxIndex )
				? ( activeIndex + 1 )
				: 0
			;

			applyActive();

		}

		function clearActive() {

			notes[ activeIndex ].classList.remove( "active" );

		}

		function applyActive() {

			notes[ activeIndex ].classList.add( "active" );

		}

	})();



	(function setupBackgroundSave() {

		var form = document.querySelector( ".perform-exercise" );
		var submitTimer = null;

		form.addEventListener( "input", prepareForAutoSubmit );
		form.addEventListener( "submit", handleSubmit );

		// I handle the submit event on the form.
		function handleSubmit() {

			// If the user is submitting the form, we want to cancel any pending
			// background submit timer that is in-flight.
			clearTimeout( submitTimer );

		}

		// I setup the background timer for auto-save.
		function prepareForAutoSubmit() {

			clearTimeout( submitTimer );
			submitTimer = setTimeout( autoSubmitForm, 750 );

		}

		// I POST the form to the server in the background.
		function autoSubmitForm() {

			var formAction = form.getAttribute( "action" );
			var formMethod = form.getAttribute( "method" );
			var formData = new FormData( form );

			fetch(
				formAction,
				{
					method: formMethod,
					body: formData
				}
			).catch(
				( error ) => {

					// NOTE: This only represents transport errors, not HTTP error
					// responses from the server. We don't care about server
					// responses since we're only optimistically saving the form.
					console.group( "Auto submit error" );
					console.error( error );
					console.groupEnd();

				}
			);

		}

	})();
	
	class CircularProgressBar {
		constructor(elementId) {
			this.el = document.getElementById(elementId);

			if (!this.el) {
				//element was not found
				return;
			}
		
			// Initialize options from the element's data attributes
			this.options = {
				current: parseFloat(this.el.getAttribute('data-current')) || 0,
				intensityMultiplier: parseFloat(this.el.getAttribute('data-intensity-multiplier')) || 0,
				max: parseFloat(this.el.getAttribute('data-max')) || 100,
				size: parseInt(this.el.getAttribute('data-size')) || 150,
				lineWidth: parseInt(this.el.getAttribute('data-line')) || 10,
				rotate: parseInt(this.el.getAttribute('data-rotate')) || 0,
			};
		
			// Calculate initial percentage
			this.options.percent = (this.options.current / this.options.max) * 100;
		
			// Create canvas and span elements
			this.canvas = document.createElement('canvas');
			this.span = document.createElement('span');
			this.el.style.width = `${this.options.size}px`;
			this.el.style.height = `${this.options.size}px`;
		
			// Append elements to the parent container
			this.el.appendChild(this.span);
			this.el.appendChild(this.canvas);
		
			// Setup canvas context
			if (typeof G_vmlCanvasManager !== 'undefined') {
				G_vmlCanvasManager.initElement(this.canvas);
			}
			this.ctx = this.canvas.getContext('2d');
			this.canvas.width = this.canvas.height = this.options.size;
		
			// Translate and rotate context
			this.ctx.translate(this.options.size / 2, this.options.size / 2);
			this.ctx.rotate((-1 / 2 + this.options.rotate / 180) * Math.PI);
		
			// Set radius
			this.radius = (this.options.size - this.options.lineWidth) / 2;
		
			// Initial draw
			this.draw();
		}
		
		draw() {
			if (!this.el) { return; }
			const drawCircle = (color, lineWidth, percent) => {
			percent = Math.min(Math.max(0, percent), 1); // Clamp between 0 and 1
			this.ctx.beginPath();
			this.ctx.arc(0, 0, this.radius, 0, Math.PI * 2 * percent, false);
			this.ctx.strokeStyle = color;
			this.ctx.lineCap = 'round'; // Line cap: round
			this.ctx.lineWidth = lineWidth;
			this.ctx.stroke();
			};
		
			// Clear the canvas
			this.ctx.clearRect(-this.options.size / 2, -this.options.size / 2, this.options.size, this.options.size);
		
			// Draw the background and progress
			drawCircle('#efefef', this.options.lineWidth, 1); // Background
			drawCircle('#4caf50', this.options.lineWidth, this.options.percent / 100); // Progress
		
			// Update text in the center
			this.span.textContent = `${Math.round(this.options.percent)}%`;
		}
		
		update(current) {
			if (!this.el) { return; }
			
			this.options.current = current;

			if ( this.options.max  == 0){
				this.options.percent = 0;
			}
			else{
				this.options.percent = (current / this.options.max) * 100;
			}
			
			this.draw();
		}

		getIntensityMultiplierRatio(set1RM){
			if (!this.el) { return; }
			if(this.options.intensityMultiplier === 0 || isNaN(set1RM) || set1RM === 0){
				return 1;
			}

			return set1RM/this.options.intensityMultiplier;
		}
	}
		
	// Initialize a circular progress bar
	const volumeProgressBar = new CircularProgressBar('volume-graph');

	function handleChartingUpdates(){
		//need to hunt down all of the sets and reps and create a volume

		let totalVolume = 0;

		// Get all the sets
		const sets = document.querySelectorAll('.set');

		// Iterate over each set
		sets.forEach((set) => {
			const weightInput = set.querySelector('.set__weight');
			const repsInput = set.querySelector('.set__reps');
		
			// Parse weight and reps values
			const weight = parseFloat(weightInput.value) || 0;
			const reps = parseInt(repsInput.value, 10) || 0;
			const estimated1RM = estimate1RM(weight,reps);
		
			// Calculate the volume for this set
			totalVolume += weight * reps * volumeProgressBar.getIntensityMultiplierRatio(estimated1RM);
		});

		// Update the progress bar
		volumeProgressBar.update(totalVolume);
	}

	handleChartingUpdates();

	/**
	 * Estimate a 1RM based on a given weight and rep count using the Brzycki Equation.
	 * Ensures that weight and reps are numeric values.
	 * This also exists in client.main.lib.ExerciseMax.cfc, but we need to use it for the real-time charting as well
	 *
	 * @param {number|string} weight - The weight used for the calculation.
	 * @param {number|string} reps - The number of reps used for the calculation.
	 * @returns {number} The estimated 1RM, or 0 if the calculation is invalid.
	*/
	function estimate1RM(weight, reps) {
		// Ensure weight and reps are numeric
		weight = isNaN(weight) ? 0 : parseFloat(weight);
		reps = isNaN(reps) ? 0 : parseInt(reps, 10);
	
		// Using the Brzycki Equation
		const denominator = 1.0278 - (0.0278 * reps);
	
		if (denominator === 0) {
			return 0;
		}
	
		return weight / denominator;
	}
  
	
	  
	  
	  
	  

}
